// extracted by mini-css-extract-plugin
export var conversationListItem = "_wv-2";
export var fullBleedList = "_wv-3";
export var messageText = "_wv-1";
export var previewText = "_wv-0";